import { nerdNetworkBaseQuery } from "@nerdjs/nerd-network";
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseApi";

export const librarianApi = createApi({
  reducerPath: "librarianApi",
  baseQuery: (args, api) => baseQuery(args, api, { service: "librarian" }),
  endpoints: () => ({}),
  tagTypes: ["pieces"],
});
